import { render, staticRenderFns } from "./ICForm.vue?vue&type=template&id=6ef51402&"
import script from "./ICForm.vue?vue&type=script&lang=js&"
export * from "./ICForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.10.2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports